
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'AbdominalTumorRelatedMarkers',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/AbdominalTumorRelatedMarkers.vue